import graphqlClient from "../../../apollo";

class BranchProvider {

    findBranch(id) {
        return graphqlClient.query({
            query: require('./gql/Branch/findBranch.graphql'),
            fetchPolicy: "network-only",
            variables: {id:id}
        })
    }

    findBranchDefault() {
        return graphqlClient.query({
            query: require('./gql/Branch/findBranchDefault.graphql'),
            fetchPolicy: "network-only"
        })
    }


    fetchBranch() {
        return graphqlClient.query({
            query: require('./gql/Branch/fetchBranch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateBranch(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Branch/paginateBranch.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createBranch(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Branch/createBranch.graphql'),
            variables: {input}
        })
    }

    updateBranch(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Branch/updateBranch.graphql'),
            variables: {id, input}
        })
    }

     deleteBranch(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Branch/deleteBranch.graphql'),
            variables: {id}
        })
    }

}

export default new BranchProvider()


